import Courses from "../components/courses"
import Header from "../components/header"
import Footer from "../components/footer"

const CoursePage =()=>{
    return(
        <>
        {<Header/>}
        {<Courses/>}
       
        </>
    )
}
export default CoursePage